export const RangeField = {
  parts: ['Control', 'Label', 'Input', 'Range', 'LessMore', 'HelperText'],
  baseStyle: {
    Control: {
      margin: '0 0 32px 0',
    },
    Label: {
      marginBottom: '26px',
      fontSize: '18px',
      color: 'brand.black',
    },
    Input: {
      maxWidth: '250px',
      margin: '16px auto',
      textAlign: 'center',
      fontSize: '20px',
      fontWeight: 'bold',
      border: 'solid 2px',
      borderColor: 'brand.lightgrey',
      padding: '0.6em',
      ':focus': {
        borderColor: 'blue.500', // the default Chakra UI focus ring colour
        boxShadow: 'var(--chakra-shadows-outline)',
      },
    },
    Range: {
      fontSize: '14px',
      fontWeight: 400,
    },
    LessMore: {
      fontSize: '14px',
      marginTop: '24px',
    },
    HelperText: {},
  },
};
